module.exports = __webpack_public_path__ + "static/media/entranceM.f8716b33.jpg";